import type HttpClient from "../../tastyworks/http"
import {
  RECOVERY_CODES_STATUS_DESER,
  RecoveryCodesStatus,
} from "../../tastyworks/recovery-codes"
import {
  parseSingleResponse,
  SingleResponse,
  updateSingleResponse,
} from "../../tastyworks/response"

export class RecoveryCodesService {
  private readonly recoveryCodesClient: HttpClient

  constructor(userMeClient: HttpClient) {
    this.recoveryCodesClient = userMeClient.nested("recovery-codes")
  }

  readonly getStatus = async (): Promise<
    SingleResponse<RecoveryCodesStatus>
  > => {
    const helper = await this.recoveryCodesClient.get("status")
    return updateSingleResponse(
      helper,
      new RecoveryCodesStatus(),
      RECOVERY_CODES_STATUS_DESER.update
    )
  }

  readonly generate = async (): Promise<
    SingleResponse<{ codes: string[] }>
  > => {
    const helper = await this.recoveryCodesClient.postJson("generate", {})
    return parseSingleResponse(helper, (data) => ({
      codes: data.getPrimitiveArray("recovery-codes") as string[],
    }))
  }
}
